import {Component, OnInit, ViewChild} from '@angular/core';
import {OrderService} from '../../services/order.service';
import {DataTableDirective} from 'angular-datatables';
import {first} from 'rxjs/operators';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {NgxSpinnerService} from 'ngx-spinner';
import {ToastrService} from 'ngx-toastr';
import {OrderDetailModalComponent} from './order-detail-modal/order-detail-modal.component';
import {ConfirmOrderModalComponent} from "./confirm-order-modal/confirm-order-modal.component";

@Component({
    selector: 'app-orders',
    templateUrl: './orders.component.html',
    styleUrls: ['./orders.component.scss']
})
export class OrdersComponent implements OnInit {

    dtOptions: DataTables.Settings = {};
    orders: any[];
    @ViewChild(DataTableDirective) private dtElement;

    constructor(
        private modalService: NgbModal,
        private orderService: OrderService,
        private toastrService: ToastrService,
        private ngxSpinnerService: NgxSpinnerService,
    ) {
    }

    ngOnInit(): void {
        this.dtOptions = {
            pagingType: 'full_numbers',
            pageLength: 10,
            serverSide: true,
            processing: true,
            order: [[0, 'desc']],
            ajax: (dataTablesParameters: any, callback) => {
                this.orderService.getActiveDatatable(dataTablesParameters)
                    .pipe(first())
                    .subscribe(response => {
                        this.orders = response.data;
                        callback({
                            recordsTotal: response.recordsTotal,
                            recordsFiltered: response.recordsFiltered,
                            data: []
                        });
                    });
            },
            columns: [
                {data: 'created_at'},
                {data: 'code'},
                {data: 'delivery_amount'},
                {data: 'total'},
                {data: 'total'},
                {data: 'payment_method_nice', name: 'payment_method'},
                {data: 'status_nice', name: 'status'},
            ]
        };
    }

    private async reloadTable() {
        let dtIntance = await this.dtElement.dtInstance;
        dtIntance.ajax.reload();
    }

    show(order: any): void {
        this.ngxSpinnerService.show();
        this.orderService.getById(order.id).subscribe(response => {
            const modalRef = this.modalService.open(OrderDetailModalComponent, {
                size: 'xl'
            });
            modalRef.result.then(result => {
                this.reloadTable();
            }).catch(reason => {
            });
            modalRef.componentInstance.order = response.data.order;
            modalRef.componentInstance.items = response.data.items;
            this.ngxSpinnerService.hide();
        }, error1 => {
            this.toastrService.error(error1);
            this.ngxSpinnerService.hide();
        });
    }

    onStatus(order: any): void {
        if (order.status != 4 && order.status != 1 && order.status != 8 && order.status != 5) {
            const modalRef = this.modalService.open(ConfirmOrderModalComponent, {
                size: 'lg',
                centered: true,
            });
            modalRef.result.then(result => {
                this.reloadTable();
            }).catch(reason => {
            });
            modalRef.componentInstance.order = order;
        }
    }
}
